import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ResultsCard1,
  ResultsCard2,
  ResultsFeel,
  ResultsFeelDesc1,
  ResultsFeelDesc2,
} from '../../../Constants';
import CustomerPhoto from '../../../assets/testimonials/vanessa-kitchen.webp';

const TrendUpIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <polyline points="3 17 9 11 13 15 21 7" />
    <polyline points="15 7 21 7 21 13" />
  </svg>
);

const ThumbsUpIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M7 11v9H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1z" />
    <path d="M7 11l4-7a2 2 0 0 1 2 2v4h5.5a2 2 0 0 1 1.94 2.5l-1.5 6A2 2 0 0 1 17 20H9a2 2 0 0 1-2-2" />
  </svg>
);

const StatCard = ({ icon: Icon, value, label }) => (
  <div className="t-flex t-flex-col t-gap-2 t-bg-navy/[0.04] t-border t-border-navy/10 t-rounded-xl t-p-4">
    <Icon className="t-h-7 t-w-7 t-text-quiz-teal" />
    <span className="!t-m-0 t-font-serif t-font-normal t-text-navy t-text-[32px] lg:t-text-[38px] t-leading-none">
      {value}
    </span>
    <p className="!t-m-0 t-font-sans t-text-[13px] t-text-navy/70 t-leading-snug">{label}</p>
  </div>
);

const ResultYouFeel = ({ cta }) => {
  const { t } = useTranslation();
  return (
    <div className="t-flex t-flex-col-reverse lg:t-flex-row t-items-center t-gap-6 lg:t-gap-12">
      <div className="t-w-full lg:t-w-1/2">
        <img
          src={CustomerPhoto}
          alt=""
          className="t-w-full t-h-[280px] lg:t-h-[420px] t-object-cover t-rounded-2xl"
        />
      </div>
      <div className="t-w-full lg:t-w-1/2 t-flex t-flex-col t-gap-4">
        <div className="t-flex t-flex-col t-gap-1 t-text-center lg:t-text-left">
          <h2 className="t-text-[24px] md:t-text-[30px] !t-m-0 t-font-serif t-font-normal t-text-navy">{t(ResultsFeel)}</h2>
          <p className="!t-m-0 t-font-sans t-text-[15px] t-text-navy/70">{t(ResultsFeelDesc1)}</p>
          <p className="!t-m-0 t-font-sans t-text-[15px] t-text-navy/70">{t(ResultsFeelDesc2)}</p>
        </div>
        <div className="t-grid t-grid-cols-2 t-gap-3">
          <StatCard icon={TrendUpIcon} value="87%" label={t(ResultsCard1)} />
          <StatCard icon={ThumbsUpIcon} value="83%" label={t(ResultsCard2)} />
        </div>
        {cta && <div className="t-mt-2">{cta}</div>}
      </div>
    </div>
  );
};

export default ResultYouFeel;
